function getTemperatureSymbol(unit?: string) {
  if (unit === 'celsius') {
    return '°C'
  }
  return '°F'
}

export function formatTemperature(temperature?: string | number, unit?: string) {
  if (!temperature) {
    return ''
  }
  return `${temperature}${getTemperatureSymbol(unit)}`
}
